import angular from 'angular';
import queryTree from './queryTree'; 

export default angular
    .module('app.queryTree', []) 
    .directive('queryTree',queryTree)
    .name;


// WEBPACK FOOTER //
// ./src/components/queryTree/index.js